import React, { useEffect, useState } from "react";
import Header from "./layout/Header";
import NavBar from "./layout/NavBar";
import Footer from "./layout/Footer";
import { Link, useNavigate } from "react-router-dom";
import { logout, setPageInfo, setTabID } from "../utility/Common";

function Home() {
  let navigate = useNavigate();
  const sendStateRenew = () => {
    logout()
    setTabID()
    //const state = { pageName: "renew" };
    setPageInfo({ pageName: "renew" })
    navigate("/emailverification");
  };

  const sendStateNew = () => {
    logout()
    setTabID()
    // const state = { pageName: "new" };
    setPageInfo({ pageName: "new" })
    navigate("/emailverification");
  };

  const pageStyles = {
    paddingLeft: "20px",
    paddingRight: "20px",
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "1200px",
  };

  const cardStyle = {
    padding: "15px",
    borderRadius: "8px",
    boxShadow: "rgba(0,0,0,0.1)",
  };

  return (
    <>
      <Header />
      <div className="container">
        <NavBar />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12 module-content2">
            <div
              className="col-md-12 col-sm-12 col-xs-12 tab-registration-container"
              style={{ marginTop: "-5px" }}
            >
              <br />
              <div className="col-sm-12 text-justify">
                <h5 className="page-header m-r-t-1">
                  <a href="/">Mfumo wa Hati ya Dharura</a>
                </h5>
                <p className="text-justify lead" style={{ fontSize: "100%" }}>
                  Hii ni huduma mpya inayokuwezesha mwombaji kujaza Fomu na
                  kupata ETD kwa njia ya Kielektroniki ukiwa mahali popote. Kwa
                  mwombaji anayetumia namba ya pasipoti au anayeomba ETD kwa
                  mara ya pili(Renew), baada ya kukamilisha ombi, atatakiwa
                  kuchapisha (Print) kibali cha dharula tayari kwa matumizi. Kwa
                  mwombaji anayetumia namba ya NIDA au Kitambulisho cha
                  mdhamini, baada ya kukamilisha ombi, atatakiwa kuchapisha
                  (Print) fomu na kuiwasilisha pamoja na viambata vingine katika
                  Ofisi ya Uhamiaji iliyo karibu naye kwa ajili ya kuchakata na
                  baada ya hapo mwombaji ataweza kuchapisha(Print) ETD tayari
                  kwa matumizi.
                </p>
                <br />
              </div>



              <div style={pageStyles}>
                <section id="what-we-do">
                  <h5 className="page-header m-r-t-1">
                    <a href="/">CHAGUA HUDUMA</a>
                  </h5>
                  <br />
                  <div className="row mt-5">
                    <div className="col-12 col-sm-6 col-md-4">
                      <div className="card" style={cardStyle}>
                        <div className="card-block block-1">
                          <h3 className="card-title page-header m-reset-0">
                            Ombi Jipya
                          </h3>
                          <p className="card-text">Kwa Mwombaji Mpya.</p>
                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              sendStateNew();
                            }}
                            className="read-more"
                          >
                            Ombi Jipya{" "}
                            <i className="ml-2 fa fa-angle-double-right"></i>
                          </Link>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-sm-6 col-md-4">
                      <div className="card" style={cardStyle}>
                        <div className="card-block block-3">
                          <h3 className="card-title page-header m-reset-0">
                            Huisha (Renew)
                          </h3>
                          <p className="card-text">
                            Kubadili hati iliyomaliza Muda.
                          </p>
                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              sendStateRenew();
                            }}
                            className="read-more"
                          >
                            Huwisha Ombi{" "}
                            <i className="ml-2 fa fa-angle-double-right"></i>
                          </Link>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-sm-6 col-md-4">
                      <div className="card" style={cardStyle}>
                        <div className="card-block block-2">
                          <h3 className="card-title page-header m-reset-0">
                            Endeleza/Angalia Ombi
                          </h3>
                          <p className="card-text">
                            Kuendeleza ombi ulipoishia.
                          </p>
                          <Link to="/continue" className="read-more">
                            Endeleza/Angalia Ombi{" "}
                            <i className="ml-2 fa fa-angle-double-right"></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <br />
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}
export default Home;
